import { useState } from 'react'
import { CircleHelp } from 'lucide-react'
import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { claudeConnectUrl } from '../lib/claudeLinks'
import { messages } from '../messages'
import { ClaudeIcon } from './BrandIcons'
import { ClaudeConnectDialog } from './ClaudeConnectDialog'

/** Вкладка Claude: подключение одной ссылкой и рядом — пошаговый гайд в окне. */
export const ClaudeConnectButton = () => {
  const [open, setOpen] = useState(false)
  const m = useMessages(messages)
  return (
    // На телефоне кнопки столбиком во всю ширину — под палец; с `sm` — рядом, по содержимому.
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
      <Button asChild size="lg" className="w-full sm:w-auto">
        <a href={claudeConnectUrl()} target="_blank" rel="noopener noreferrer">
          <ClaudeIcon />
          {m.connectClaude}
        </a>
      </Button>
      <Button
        variant="secondary"
        size="lg"
        className="w-full sm:w-auto"
        onClick={() => setOpen(true)}
      >
        <CircleHelp />
        {m.claudeGuide}
      </Button>
      <ClaudeConnectDialog open={open} onOpenChange={setOpen} />
    </div>
  )
}
